<template>
  <div id="choose-product" class="tw-w-full tw-px-4 md:tw-px-8 tw-mt-12 tw-mb-6 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-6 md:tw-gap-8 tw-pb-5">
    <v-card
        id="motor-insurance"
        class="mx-auto tw-w-full md:tw-w-80 tw-rounded-xl tw-shadow-lg hover:tw-shadow-2xl tw-transition-all tw-duration-300 tw-transform hover:tw-scale-105 tw-mt-6 md:tw-mt-3 tw-overflow-hidden"
        elevation="4"
    >
      <!-- Header with gradient -->
      <div class="tw-bg-gradient-to-br tw-from-blue-900 tw-to-blue-800 tw-p-6 tw-text-center tw-relative">
        <div class="tw-absolute tw-top-2 tw-right-2">
          <v-chip small color="white" text-color="blue">Popular</v-chip>
        </div>  <v-icon size="64" alt="car" class="gradient-icon-header">mdi-car-outline</v-icon>
        <h3 class="tw-text-white tw-font-bold tw-text-xl tw-mt-3">Motor Insurance</h3>
        <p class="tw-text-blue-100 tw-text-sm tw-mt-1">Comprehensive vehicle protection</p>
      </div>
      <!-- Features section -->
      <div class="tw-p-6 tw-bg-white">
        <div class="tw-mb-6">
          <h4 class="tw-text-gray-800 tw-font-semibold tw-text-sm tw-mb-4 tw-border-b tw-border-gray-200 tw-pb-2">What's Included:</h4>
          <div class="tw-space-y-3">
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-green-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-blue">mdi-shield-check-outline</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Third Party & Comprehensive Cover</span>
            </div>
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-green-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-blue">mdi-car</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Windscreen & Towing Services</span>
            </div>
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-green-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-blue">mdi-account-group</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Passenger Legal Liability</span>
            </div>
          </div>
        </div>
        <!-- Action button -->
        <v-btn id="proceed" color="primary" block large class="tw-rounded-lg tw-font-semibold" @click="proceedCar">
          <v-icon left>mdi-calculator-variant</v-icon>
          Get Your Quote
        </v-btn>
      </div>
    </v-card>
    <v-card
        id="marine-insurance"
        class="mx-auto tw-w-full md:tw-w-80 tw-rounded-xl tw-shadow-lg hover:tw-shadow-2xl tw-transition-all tw-duration-300 tw-transform hover:tw-scale-105 tw-mt-6 md:tw-mt-3 tw-overflow-hidden"
        elevation="4"
    >
      <!-- Header with gradient -->
      <div class="tw-bg-gradient-to-br tw-from-teal-900 tw-to-teal-800 tw-p-6 tw-text-center tw-relative">
        <div class="tw-absolute tw-top-2 tw-right-2">
          <v-chip small color="white" text-color="teal">Medical</v-chip>
        </div>  <v-icon size="64" alt="medical" class="gradient-icon-header">mdi-hospital-box-outline</v-icon>
        <h3 class="tw-text-white tw-font-bold tw-text-xl tw-mt-3">Pacis Amani</h3>
        <p class="tw-text-teal-100 tw-text-sm tw-mt-1">Complete medical coverage for your family</p>
      </div>
      <!-- Features section -->
      <div class="tw-p-6 tw-bg-white">
        <div class="tw-mb-6">
          <h4 class="tw-text-gray-800 tw-font-semibold tw-text-sm tw-mb-4 tw-border-b tw-border-gray-200 tw-pb-2">Medical Benefits:</h4>
          <div class="tw-space-y-3">
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-teal-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-teal">mdi-hospital-building</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Inpatient & Outpatient Care</span>
            </div>      <div class="tw-flex tw-items-center tw-p-2 tw-bg-teal-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-teal">mdi-baby-carriage</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Maternity & Dental Cover</span>
            </div>      <div class="tw-flex tw-items-center tw-p-2 tw-bg-teal-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-teal">mdi-ambulance</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Emergency Services</span>
            </div>    </div>
        </div>
        <!-- Action buttons -->
        <div class="tw-space-y-3">
          <v-btn id="marine" color="primary" block large class="tw-rounded-lg tw-font-semibold" @click="proceedAmani()">
            <v-icon left>mdi-calculator-variant</v-icon>
            Get Your Quote
          </v-btn>
          <v-btn color="secondary" outlined block class="tw-rounded-lg" @click="downloadBrochure()">
            <v-icon left>mdi-download</v-icon>
            Download Brochure
          </v-btn>
        </div></div>
    </v-card>
    <v-card
        id="domestic-package"
        class="mx-auto tw-w-full md:tw-w-80 tw-rounded-xl tw-shadow-lg hover:tw-shadow-2xl tw-transition-all tw-duration-300 tw-transform hover:tw-scale-105 tw-mt-6 md:tw-mt-3 tw-overflow-hidden"
        elevation="4"
    >
      <!-- Header with gradient -->
      <div class="tw-bg-gradient-to-br tw-from-orange-900 tw-to-orange-800 tw-p-6 tw-text-center tw-relative">
        <div class="tw-absolute tw-top-2 tw-right-2">
          <v-chip small color="white" text-color="orange">Home</v-chip>
        </div>  <v-icon size="64" alt="home" class="gradient-icon-header">mdi-home-circle-outline</v-icon>
        <h3 class="tw-text-white tw-font-bold tw-text-xl tw-mt-3">Domestic Package</h3>
        <p class="tw-text-orange-100 tw-text-sm tw-mt-1">Protect your home and valuable assets</p>
      </div>
      <!-- Features section -->
      <div class="tw-p-6 tw-bg-white">
        <div class="tw-mb-6">
          <h4 class="tw-text-gray-800 tw-font-semibold tw-text-sm tw-mb-4 tw-border-b tw-border-gray-200 tw-pb-2">Coverage Includes:</h4>
          <div class="tw-space-y-3">
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-orange-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-orange">mdi-home-variant</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">House & Contents Protection</span>
            </div>      <div class="tw-flex tw-items-center tw-p-2 tw-bg-orange-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-orange">mdi-television</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Electronics & Appliances</span>
            </div>      <div class="tw-flex tw-items-center tw-p-2 tw-bg-orange-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-orange">mdi-shield-lock</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Theft & Burglary Cover</span>
            </div>    </div>
        </div>
        <!-- Action button -->
        <v-btn id="domesticPackage" color="primary" block large class="tw-rounded-lg tw-font-semibold" @click="proceedDP()">
          <v-icon left>mdi-calculator-variant</v-icon>
          Get Your Quote
        </v-btn>
      </div>
    </v-card>
    <v-card
        id="travel-insurance"
        class="mx-auto tw-w-full md:tw-w-80 tw-rounded-xl tw-shadow-lg hover:tw-shadow-2xl tw-transition-all tw-duration-300 tw-transform hover:tw-scale-105 tw-mt-6 md:tw-mt-3 tw-overflow-hidden"
        elevation="4"
    >
      <!-- Header with gradient -->
      <div class="tw-bg-gradient-to-br tw-from-yellow-900 tw-to-yellow-800 tw-p-6 tw-text-center tw-relative">
        <div class="tw-absolute tw-top-2 tw-right-2">
          <v-chip small color="white" text-color="amber">Travel</v-chip>
        </div>
        <v-icon size="64" alt="travel" class="gradient-icon-header">mdi-airplane</v-icon>
        <h3 class="tw-text-white tw-font-bold tw-text-xl tw-mt-3">Travel Insurance</h3>
        <p class="tw-text-yellow-100 tw-text-sm tw-mt-1">Complete travel protection worldwide</p>
      </div>
      <!-- Features section -->
      <div class="tw-p-6 tw-bg-white">
        <div class="tw-mb-6">
          <h4 class="tw-text-gray-800 tw-font-semibold tw-text-sm tw-mb-4 tw-border-b tw-border-gray-200 tw-pb-2">Coverage Includes:</h4>
          <div class="tw-space-y-3">
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-yellow-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-yellow">mdi-hospital-box</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Medical Emergency Coverage</span>
            </div>
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-yellow-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-yellow">mdi-calendar-remove</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Trip Cancellation & Interruption</span>
            </div>
            <div class="tw-flex tw-items-center tw-p-2 tw-bg-yellow-50 tw-rounded-lg">
              <v-icon small class="tw-mr-3 gradient-icon-yellow">mdi-bag-suitcase</v-icon>
              <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Luggage & Personal Effects</span>
            </div>
          </div>
        </div>
        <!-- Action button -->
        <v-btn id="travel" color="primary" block large class="tw-rounded-lg tw-font-semibold" @click="proceedTravel()">
          <v-icon left>mdi-calculator-variant</v-icon>
          Get Your Quote
        </v-btn>
      </div>
    </v-card>
    <!-- <v-card
        id="personal-accident"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat
    >
      <v-icon color="primary" size="80" alt="car">mdi-bandage</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text title-font tw-text-base md:tw-text-xl tw-px-3 tw-mt-4">Personal Accident</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Cover yourself and your family
          against accidents</p>
        <v-btn id="marine" href="http://212.22.167.19/pacisapp/backend/web/personal-accident-packages/create" target="_blank" color="primary" class="my-3" @click="$analytics.logEvent(marineName)">
          Get Quote
        </v-btn>
      </div>
    </v-card> -->
    <!-- <v-card
        id="travel-insurance"
        class="mx-auto tw-full md:tw-w-64 tw-px-3 tw-py-3 md:tw-py-8 tw-flex tw-flex-wrap tw-justify-center tw-bg-left-bottom bg-size tw-mt-6 md:tw-mt-3" flat
    >
      <v-icon color="primary" size="80" alt="car">mdi-shield-airplane-outline</v-icon>
      <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-center">
        <h3 class="c-blue-text title-font tw-text-base md:tw-text-xl tw-px-3 tw-mt-4">Travel Insurance</h3>
        <p class="c-gray-text tw-w-full tw-text-sm tw-text-center">Planning to Travel?</p>
        <v-btn id="travel" href="" target="_blank" color="primary" class="my-3" @click="$analytics.logEvent(travelName)">
          Get Quote
        </v-btn>
      </div>
    </v-card> -->
  </div>
</template>

<script>
import {
  FB_CHOOSE_AMANI,
  FB_CHOOSE_MARINE, FB_CHOOSE_RFQ, FB_CHOOSE_TRAVEL, FB_INIT, FB_CHOOSE_DOMESTIC,
} from '@/utils/const';

export default {
  name: 'ChooseProduct',
  mounted() {
    this.$analytics.logEvent(FB_INIT, { product: 'Insurance Products' });
  },
  computed: {
    travelName() {
      return FB_CHOOSE_TRAVEL;
    },
    marineName() {
      return FB_CHOOSE_MARINE;
    },
  },
  methods: {
    proceedCar() {
      this.$analytics.logEvent(FB_CHOOSE_RFQ, { product: 'Motor Private' });
      this.$emit('proceed-request');
    },
    proceedAmani() {
      this.$analytics.logEvent(FB_CHOOSE_AMANI);
      this.$emit('proceed-amani-request');
    },
    async downloadBrochure() {
      try {
        const response = await fetch('https://bit.ly/3ZMMRwq');
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Pacis_Amani_Brochure.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        // Fallback: open in new tab if download fails
        window.open('https://bit.ly/3ZMMRwq', '_blank');
      }
    },
    proceedDP() {
      this.$analytics.logEvent(FB_CHOOSE_DOMESTIC);
      this.$emit('proceed-dp-request');
    },
    proceedTravel() {
      this.$analytics.logEvent(FB_CHOOSE_TRAVEL);
      this.$emit('proceed-travel-request');
    },
  },
};
</script>

<style scoped>
.bg-size {
  background-size: 80px;
}

/* Gradient icon styles */
.gradient-icon-header {
  background: linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-icon-blue {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-icon-teal {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 50%, #5eead4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-icon-orange {
  background: linear-gradient(135deg, #c2410c 0%, #f97316 50%, #fdba74 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-icon-yellow {
  background: linear-gradient(135deg, #d97706 0%, #f59e0b 50%, #fbbf24 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
